module.exports = __webpack_public_path__ + "workflow.png?ec181c44f8c27a69d3c2a58342d9c6cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workflow.png
// module id = 38
// module chunks = 0